<div class="login-container">
	<div class="login-top">
		<div class="left-side">
			<img src="assets/images/Tecnalia_Logo.jpg" draggable="false" alt="Tecnalia Logo">
		</div>
		<div class="right-side">
			<form id="login-body">
				<div class="title-1 login-title">
					Login error
				</div>
				<div class="error-msg">
					An error occurred during the login process.
				</div>
				<div class="error-msg">
					Please try again later or contact the IT department.
				</div>
				<a class="login-link" role="button" (click)="login()">
					Log in again
				</a>
			</form>
		</div>
	</div>
	<div class="title-4 login-footer">
		2026 © Tecnalia Research & Innovation
	</div>
</div>